"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eurorastparkAvailabilityRecordSchema = void 0;
const zod_1 = require("zod");
exports.eurorastparkAvailabilityRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    availableSpots: zod_1.z.number().nonnegative(),
    totalSpots: zod_1.z.number().nonnegative(),
    activeMaintenance: zod_1.z.boolean(),
    timestamp: zod_1.z.string(),
});
//# sourceMappingURL=eurorastpark.js.map